/**
 * Composite — tooth-coloured filling with a soft bevel and specular sheen.
 * Renders once per selected surface, defaults to occlusal if none.
 */
import { SURFACE_POS, SURFACE_SIZE, uid } from "./_shared";

export default function Composite({ surfaces = [], toothId }) {
  const spots = (surfaces.length ? surfaces : ["O"]).filter((s) => SURFACE_POS[s]);
  const gid = uid("comp", toothId);

  return (
    <g style={{ pointerEvents: "none" }}>
      <defs>
        <radialGradient id={gid} cx="40%" cy="35%" r="75%">
          <stop offset="0%"   stopColor="#FFFDF6" />
          <stop offset="60%"  stopColor="#F1E6C9" />
          <stop offset="100%" stopColor="#D8C489" />
        </radialGradient>
      </defs>
      {spots.map((s) => {
        const { cx, cy } = SURFACE_POS[s];
        const { rx, ry } = SURFACE_SIZE[s];
        return (
          <g key={s}>
            {/* Outer bevel */}
            <ellipse cx={cx} cy={cy} rx={rx - 1} ry={ry - 1}
                     fill="#B69E58" fillOpacity={0.35} />
            {/* Body */}
            <ellipse cx={cx} cy={cy} rx={rx - 2} ry={ry - 2}
                     fill={`url(#${gid})`}
                     stroke="#9F8641" strokeWidth={0.3} strokeOpacity={0.7} />
            {/* Specular highlight */}
            <ellipse cx={cx - rx * 0.35} cy={cy - ry * 0.4}
                     rx={rx * 0.3} ry={ry * 0.25}
                     fill="#FFFFFF" fillOpacity={0.55} />
          </g>
        );
      })}
    </g>
  );
}
